module.exports = __webpack_public_path__ + "static/img/yue_zhang.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wmm/yue_zhang.jpg
// module id = CyI3
// module chunks = 0